import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DocumentMetadataDTO} from '@dto/documents/document-metadata.dto';
import {API_DOCUMENTS, API_ENTITY_DOCUMENT_DOWNLOAD, API_ENTITY_DOCUMENTS} from '../../config/urls';
import {Observable, switchMap} from 'rxjs';
import {map} from 'rxjs/operators';
import {DocumentLinkDTO} from '@dto/documents/document-link.dto';
import {UrlService} from '@shared/services/url.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  getDocumentsList(): Observable<DocumentMetadataDTO[]> {
    return this.http.get<DocumentMetadataDTO[]>(API_DOCUMENTS, { observe: 'response' }).pipe(
      map(response => response.body ?? [])
    );
  }

  getClientDocuments(clientCode: string): Observable<DocumentMetadataDTO[]> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_DOCUMENTS, clientCode);
    return this.http.get<DocumentMetadataDTO[]>(endpointUrl, { observe: 'response' }).pipe(
      map(response => response.body ?? [])
    );
  }

  getClientDocument(clientCode: string, entryNo: number): Observable<Blob> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_DOCUMENT_DOWNLOAD, clientCode, String(entryNo));
    return this.http.get<DocumentLinkDTO>(endpointUrl).pipe(
      switchMap((documentLink: DocumentLinkDTO) => this.http.get(documentLink.link, {responseType: 'blob'}))
    );
  }
}
